import { CustomDateFormatPipe } from '../../../../../../_helpers/_pipes/custom-date-format.pipe';
import { BnErrorNoticeComponent } from '../../../billing-new/bn-notice/bn-error-notice/bn-error-notice.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslatePipe, MapfreDesignLibraryModule, NgSelectModule, BnErrorNoticeComponent, CustomDateFormatPipe],
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class HomeHeaderComponent implements OnInit {
  @Input() policy: any;
  isAcmic = false;
  constructor(private acmicService: AcmicService) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
  }

  isLegacyCancelled(policy){
    return policy.policynumber.policyNumber.length !=10 && policy.policynumber.policyNumber.length !=6 && (policy.policyStatus != "ACTIVE" &&
       policy.policyStatus != "FUTURE") && (policy.billingDetails &&
         policy.billingDetails[0] &&
         policy.billingDetails[0].outstandingbalance > 0)
   }
 

}
